import type { ComponentObjectPropsOptions } from 'vue';

/**
 * Returns a component's object-form prop definitions, excluding array-form declarations.
 *
 * Consumers that need prop metadata can share this normalization while preserving their own
 * default-value evaluation rules.
 */
export function getComponentObjectProps(component: unknown): ComponentObjectPropsOptions | undefined {
	if (!component || typeof component !== 'object' || !('props' in component)) {
		return;
	}

	const { props } = component;

	if (!props || Array.isArray(props) || typeof props !== 'object') {
		return;
	}

	return props as ComponentObjectPropsOptions;
}
